import WeatherApp from "./components/WeatherApp";
import "./App.css";  

function App() {
  return <WeatherApp />;
}

export default App;